'use client';

import { Accordion } from '@base-ui/react/accordion';
import { filter } from '@repo/pandacss/styled-system/recipes';
import { useCallback, useState } from 'react';
import { MdCheck, MdCheckBoxOutlineBlank, MdExpandLess, MdExpandMore } from 'react-icons/md';
import { useShallow } from 'zustand/shallow';
import { useFilterEvents } from '../../../OffersFilter/useFilterEvents';
import { useRangeFilterOptions } from '../store/hooks';
import { useOffersFilterStore } from '../store/useOffersFilterStore';

const classes = filter();

export const MobileSelectTermLength = ({
  actionSection,
  pageIdentifier,
}: {
  actionSection: string;
  pageIdentifier: string;
}) => {
  const options = useRangeFilterOptions('cdDepositTerm');
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    useShallow(state => ({
      handleUpdateFilterFormState: state.handleUpdateFilterFormState,
      handleApplyFilters: state.handleApplyFilters,
      appliedFilters: state.appliedFilters,
    })),
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });
  const [isOpen, setIsOpen] = useState(false);

  const selectedOptions = appliedFilters?.selectedTermRanges ?? [];

  const updateSelection = useCallback(
    (label: string) => {
      const isSelected = selectedOptions.includes(label);
      const next = isSelected
        ? selectedOptions.filter(l => l !== label)
        : [...selectedOptions, label];
      setTimeout(() => {
        handleUpdateFilterFormState({ selectedTermRanges: next });
        const newState = handleApplyFilters();
        if (!newState) return;
        updateFiltersEvent({ additional_attributes: { term_length: next } });
      });
    },
    [selectedOptions, handleUpdateFilterFormState, handleApplyFilters, updateFiltersEvent],
  );

  return (
    <Accordion.Root
      defaultValue={['']}
      onValueChange={value => setIsOpen(value.includes('TERM LENGTH'))}
    >
      <Accordion.Item value="TERM LENGTH">
        <Accordion.Header className={classes.accordionHeader}>
          <Accordion.Trigger className={classes.accordionTrigger}>
            <span className={classes.accordionTriggerLabel}>TERM LENGTH</span>
            {isOpen ? (
              <MdExpandLess size={20} aria-hidden />
            ) : (
              <MdExpandMore size={20} aria-hidden />
            )}
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Panel className={classes.accordionPanel}>
          {options.map(({ label, count }) => {
            const isDisabled = !count && !selectedOptions.includes(label);
            const isSelected = selectedOptions.includes(label);
            return (
              <button
                key={label}
                type="button"
                className={classes.accordionItem}
                disabled={isDisabled}
                onClick={() => updateSelection(label)}
              >
                <span className={classes.accordionLabel}>{label}</span>
                <span className={classes.accordionItemRight}>
                  <span className={classes.accordionCount}>{count}</span>
                  <span
                    style={{ position: 'relative', width: 24, height: 24, display: 'inline-flex' }}
                  >
                    <MdCheckBoxOutlineBlank size={24} color={isSelected ? '#008254' : '#ccc'} />
                    {isSelected && (
                      <MdCheck
                        size={18}
                        color="#008254"
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%,-50%)',
                        }}
                      />
                    )}
                  </span>
                </span>
              </button>
            );
          })}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  );
};
